import React from "react";
import PureHeader from "../../shared/FrontHeader/PureHeader";
import FrontFooter from "../../shared/FrontFooter/FrontFooter";
import FrontMainNav from "../../shared/FrontMainNav/FrontMainNav";


function CGV() {
    return (
        <div className="landing-page-component">
            <PureHeader />
            <FrontMainNav />
            <div className="page-content pb-5">
                
                <h1 className="custom-page-title">
                    Conditions générales de vente
                </h1>
                <div className="container pb-4">
                    <div className="custom-politique-page-content pt-5">
                        <div className="content-all-politique pt-4 pb-3">
                            <div className="content-politique-item">
                                <h3 className="custom-sm-title custom-sm-title-uppercase pb-2">1. OBJET</h3>
                                <div className="custom-sm-value">
                                   Chez PURE ESSENCE, nous accordons une grande importance à la qualité et à la satisfaction de nos clients. Chaque commande est préparée avec soin afin de garantir des produits conformes et en parfait état.
                                </div>
                            </div>
                            <div className="content-politique-item pt-5">
                                <h3 className="custom-sm-title custom-sm-title-uppercase pb-2">2.Livraison et frais de port</h3>
                                <div className="custom-sm-value">
                                    <p>
                                                                        Nous assurons les livraisons dans Dakar sous 24 à 48h afin de vous garantir un service rapide et efficace. Pour toute commande en dehors de Dakar ou à l’international, notre équipe vous accompagne directement via WhatsApp afin de vous proposer la solution de livraison la plus adaptée.

                                Retours
                                Pour des raisons d’hygiène et de sécurité, certains produits ne peuvent être ni repris ni échangés après ouverture ou utilisation, notamment :
                                Les produits cosmétiques,
                                Les produits alimentaires,
                                Les produits d’entretien,
                                Ainsi que tout produit périssable ou sensible.  
                                    </p>
                                <p>Toutefois, un retour peut être accepté dans les cas suivants :
Produit reçu endommagé,
Erreur de produit lors de la préparation de la commande,
Produit défectueux ou non conforme.</p>
                                <p>
Toute demande de retour doit être signalée dans un délai de **24 heures après réception** de la commande, accompagnée de photos du produit concerné et de l’emballage d’origine.
</p>
                                </div>
                            </div>
                            <div className="content-politique-item pt-5">
                                <h3 className="custom-sm-title custom-sm-title-uppercase pb-2">3. Remboursements</h3>
                                <p>Après vérification et validation de la demande par notre équipe, plusieurs solutions pourront être proposées :</p>
                                <ul className="custom-instruction-list">
                                    <li className="listitem">
                                       Remplacement du produit,
                                    </li>
                                    <li className="listitem">
                                        Avoir valable sur une prochaine commande,
                                    </li>
                                     <li className="listitem">
                                        Ou remboursement partiel ou total selon la situation.
                                    </li>
                                </ul>
                                <p>Les remboursements validés sont effectués via un des moyen de paiement proposés par notre service client, dans un délai variable selon le mode de paiement choisi. </p>
                            </div>
                            <div className="content-politique-item pt-5">
                                <h3 className="custom-sm-title custom-sm-title-uppercase pb-2">4.Produits frais & surgelés</h3>
                                <div className="custom-sm-value pb-2">
                                    Les produits frais, congelés ou nécessitant une conservation spécifique ne sont ni repris ni remboursés après livraison, sauf en cas d’erreur ou de problème constaté à la réception.
                                </div>
                                {/* <ul className="custom-instruction-list">
                                    <li className="listitem">Paiement à la livraison (Cash ou chèque selon conditions).</li>
                                    <li className="listitem">Transferts d'argent mobiles (Orange Money, Wave, etc.).</li>
                                    <li className="listitem">Cartes bancaires via plateforme sécurisée.</li>
                                </ul> */}
                            </div>
                            <div className="content-politique-item pt-5">
                                <h3 className="custom-sm-title custom-sm-title-uppercase pb-2">5. Contact</h3>
                               
                                    <p className="listitem">
                                        Pour toute réclamation ou demande d’assistance, notre service client reste disponible via WhatsApp ou par email afin de vous accompagner rapidement.
                                    </p>

                            </div>
                            <div className="content-politique-item pt-5">
                                <h3 className="custom-sm-title custom-sm-title-uppercase pb-2">6. 
Qualité & Conservation des produits</h3>
                                <div className="custom-sm-value pb-2">
                                                                        <ul className="custom-instruction-list">
                                    <li className="listitem">
                                        <ul className="custom-instruction-list mt-1">
                                            <li className="listitem">Chez PURE ESSENCE, nous accordons une attention particulière à la qualité, à la fraîcheur et à la sécurité de nos produits.</li>
                                        </ul>
                                    </li>
                                    <li className="listitem">
                                        Nos produits sont formulés, préparés, stockés et conditionnés avec soin afin de garantir une qualité optimale jusqu’à leur utilisation.
                                    </li>
                                </ul>
                                <p>Les durées de conservation varient selon les catégories de produits. <br/>
Les conseils d’utilisation et de conservation sont indiqués sur chaque produit ou emballage.</p>
                                </div>
                                
                            </div>
                            <div className="content-politique-item pt-5">
                                <h3 className="custom-sm-title custom-sm-title-uppercase pb-2">7. Nous recommandons de</h3>
                                <div className="custom-sm-value">
                                    <ul className="custom-instruction-list">
                                    <li className="listitem">Conserver les produits dans de bonnes conditions,</li>
                                    <li className="listitem">Respecter les dates et les consignes indiquées,</li>
                                    <li className="listitem">Eviter l’exposition à la chaleur ou à l’humidité,</li>
                                    <li className="listitem">Utiliser les produits conformément aux recommandations..</li>
                                </ul>
                                </div>
                            </div>
                            
                            <div className="content-politique-item pt-5">
                                <div className="custom-sm-value">
                                 En cas de problème constaté à réception, notre équipe reste disponible pour vous accompagner dans les plus brefs délais.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FrontFooter />
        </div>
    );
}

export default CGV;
